import React, { useContext } from 'react';
import { WrapAudio, AudioWrapper, AudioController } from './Styled'
import { AbilityContext } from 'components/Permissions/Can';
import { permissions } from 'config/ability';
import { features } from 'keys';

/**
 * Audio (HTML5 audio player)
 * Renders a native audio player for a given file URL. Used in tables and assessment views.
 *
 * **How it works**
 * - Pass the audio URL via `input.value`.
 * - Renders nothing when `value` is empty/falsy.
 * - Download is disabled unless the user has `read` permission on `download_audio`.
 * - Volume and playback-rate controls are always hidden via `controlsList`.
 *
 * Exported as `Audio` from `components/Form`. Internal name: `AudioPlayer`.
 *
 * @param {Object} props
 * @param {Object} props.input - `{ value }` where `value` is the audio file URL.
 * @param {string} [props.input.value] - Audio source URL (e.g. `audio_file_url`).
 * @param {number|string} [props.width] - Player wrapper width.
 * @param {number|string} [props.height] - Player wrapper height.
 * @example
 * <Audio width={200} height={40} input={{ value: audioUrl }} />
 * @example
 * // In table cell
 * <Audio width={width} height={height} input={{ value: row.audio_file_url }} />
 */
const AudioPlayer = (props) => {
    const
        { input, width, height } = props,
        { value } = input

    const ability = useContext(AbilityContext)
    const canDownloadAudio = ability.can(permissions.read, features.download_audio)

    return (
        !value ||
        <AudioWrapper width={width} height={height}>
            <AudioController>
                <WrapAudio controls controlsList={`novolume ${!canDownloadAudio && "nodownload"} noplaybackrate`}>
                    <source src={value} type="audio/mpeg" />
                    {"Your browser does not support the audio tag."}
                </WrapAudio>
            </AudioController>
        </AudioWrapper>
    );
};

export default AudioPlayer;
